import filesPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  list: [],
  search: null,
};

const reducer = createReducer(INITIAL_STATE, {
  [filesPageActionTypes.FILES_PAGE_LIST_RESET]: (state: any) => ({
    ...state,
    list: [],
    search: null,
  }),
  [filesPageActionTypes.FILES_PAGE_LIST_REPLACE]: (
    state: any,
    action: any,
  ) => ({
    ...state,
    list: [...action.values],
  }),
  [filesPageActionTypes.FILES_PAGE_LIST_PUSH]: (state: any, action: any) => ({
    ...state,
    list: [...state.list, ...action.values],
  }),
  [filesPageActionTypes.FILES_PAGE_SET_SEARCH]: (state: any, action: any) => ({
    ...state,
    search: action.search,
  }),
  [filesPageActionTypes.FILES_PAGE_REMOVE_FILE_FROM_LIST]: (
    state: any,
    action: any,
  ) => ({
    ...state,
    list: state.list.filter((file: any) => action.fileId !== file.id),
  }),
  [filesPageActionTypes.FILES_PAGE_ADD_DOWNLOAD_URL_FOR_FILE]: (
    state: any,
    action: any,
  ) => ({
    ...state,
    list: state.list.map((file: any) =>
      file.id === action.fileId
        ? { ...file, downloadUrl: action.downloadUrl }
        : file,
    ),
  }),
  [filesPageActionTypes.CHANGE_FILE_IN_LIST]: (state: any, action: any) => ({
    ...state,
    list: state.list.map((file: any) =>
      action.file.id === file.id ? action.file : file,
    ),
  }),
  [filesPageActionTypes.ADD_FILE_TO_LIST]: (state: any, action: any) => {
    if (!state.list.find((file: any) => file.name === action.file.name)) {
      return {
        ...state,
        list: [...state.list, action.file],
      };
    } else {
      return state;
    }
  },
});

export default reducer;
